// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Feedback extends APIResource {
    /**
     * Modify feedback for a given step.
     */
    create(stepID, body, options) {
        return this._client.patch(path `/v1/steps/${stepID}/feedback`, { body, ...options });
    }
}
//# sourceMappingURL=feedback.mjs.map